import BSHtmlBaseBTStrategy from './BSHtmlBaseBTStrategy'

export default function BSHtmlBillableBTMoneyStrategy() {}

BSHtmlBillableBTMoneyStrategy.prototype = new BSHtmlBaseBTStrategy()

BSHtmlBillableBTMoneyStrategy.prototype.addFirstHeaderRowCells = function(row, levelsNumber) {
    this.addCreatedCell(row, this.createBillableCell(levelsNumber, "moneyType"))
}

BSHtmlBillableBTMoneyStrategy.prototype.addColumnValueCells = function(row) {
    this.addMoneyColumnValueCells(row)
}



// WEBPACK FOOTER //
// ./web/js/reports/preview/html/billingsummary/BSHtmlBillableBTMoneyStrategy.js